import AuthorizationPage from './screens/AuthorizationPage';
import {
  LoginForm,
  RegisterForm,
  ForgotPasswordForm,
  ResetPasswordForm,
} from './components/Forms';

import Logout from './screens/Logout/Logout';
import AccountActivationInfo from './screens/AccountActivation/AccountActivationInfo';
import ActivateAccount from './screens/AccountActivation/ActivateAccount';

import Dashboard from './layouts/Dashboard/Dashboard';
import AssesmentScreenContent from './screens/AssesmentScreen/AssesmentScreenContent';
import Logs from './screens/Logs';
import LoansScreenContent from './screens/DashboardsScreens/LoansScreen/LoansContent';

const routes = [
  {
    path: '/login',
    component: AuthorizationPage,
    form: LoginForm,
    title: 'AgroWe-Logowanie',
    exact: true,
  },
  {
    path: '/forgot-password',
    component: AuthorizationPage,
    form: ForgotPasswordForm,
    title: 'AgroWe-Przypomnij hasło',
    titleSubmitted: 'AgroWe-Link wysłany',
    exact: true,
  },
  {
    path: '/changePassword',
    component: AuthorizationPage,
    form: ResetPasswordForm,
    title: 'AgroWe-Reset hasła',
    titleSubmitted: 'AgroWe-Hasło zmienione',
    exact: true,
  },
  {
    path: '/logout',
    component: Logout,
    title: 'AgroWe-Wylogowywanie...',
    exact: true,
    private: true,
  },
  {
    path: '/register',
    component: AuthorizationPage,
    form: RegisterForm,
    title: 'AgroWe-Rejestracja',
    titleSubmitted: 'AgroWe-Zarejestrowano',
    exact: true,
  },
  {
    path: '/activate-info',
    component: AccountActivationInfo,
    title: 'AgroWe-Aktywacja konta',
    exact: true,
  },
  {
    path: '/activate/:userCode',
    component: ActivateAccount,
    title: 'AgroWe-Aktywacja konta',
    exact: true,
  },
  {
    path: '/dashboard/assesment',
    component: Dashboard,
    content: AssesmentScreenContent,
    exact: true,
    private: true,
  },
  {
    path: '/dashboard/loans',
    component: Dashboard,
    content: LoansScreenContent,
    exact: true,
    private: true,
  },
  {
    path: '/logs',
    component: Logs,
    exact: true,
    private: true,
  },
];
export default routes;
